<meta name="viewport" content="width=device-width, initial-scale=1.0"/>

@if (is.dataFullyInit) {
  @if (is.tokenValid) {
    <div class="reset-password">
      <div class="page-container top-fix resize-index flex flex-col justify-start items-center min-height-100vh">
        <div
          class="white-card login-content !w-[33.25em] mobile:!w-auto flex flex-col gap-y-[1.5625em]"
          [ngClass]="{ 'no-propagation opacity0p5 no-cursor' : is.formDisabled }">
          <div class="flex flex-col gap-y-[0.625em] text-center">
            <div class="login-title line-height-120">Create new password</div>
          </div>

          <!--send password form-->
          <form
            id="wf-form-Login"
            class="flex flex-col gap-y-[1.25em]"
            name="wf-form-Login"
            [formGroup]="pwdFormService.form"
            (ngSubmit)="onSubmit()">
            <div class="flex flex-col justify-center items-stretch gap-[0.46875em]">
              <app-input
                data-qa="create-password"
                class="password-control centered-text flex-grow"
                formControlName="password"
                [type]="pwdInput.inputType"
                [suffixFirstIcon]="pwdInput.icon"
                [placeholder]="'Create password'"
                (suffixFirstIconEmitter)="pwdInput.switchState()"
              />
              <app-password-strength-meter [pwdFormService]="pwdFormService"/>
            </div>
            <div class="password-control flex flex-col justify-center items-stretch ">
              <app-input
                data-qa="repeat-password"
                class="centered-text flex-grow"
                formControlName="confirmPassword"
                [type]="confirmPwdInput.inputType"
                [suffixFirstIcon]="confirmPwdInput.icon"
                [placeholder]="'Repeat password'"
                (suffixFirstIconEmitter)="confirmPwdInput.switchState()"
              />
            </div>

            @if (!is.agreementAlreadySigned) {
              <app-checkbox
                data-qa="terms-and-conditions-checkbox"
                formControlName="agreement"
                [checkBoxStyle]="'icon-size-1em-mobile'"
                [checked]="pwdFormService.form.value.agreement"
                [required]="true">
                <span class="font-medium">
                  I agree with
                  <a data-qa="terms-of-use" class="link-color" [href]="WEBSITE_PROD_ORCA_TERMS_OF_USE" [target]="'_blank'">terms of use</a> and
                  <a data-qa="privacy-policy" class="link-color" [href]="WEBSITE_PROD_ORCA_PRIVACY_POLICY" [target]="'_blank'">privacy policy</a>.
                </span>
              </app-checkbox>
            }

            <app-button
              data-qa="submit-new-password"
              type="submit"
              data-wait="Please wait..."
              class="create-button-wrapper entrance-button submit-button w-button bold500 clickable"
              [ngClass]="pwdFormService.form.valid? '': 'cursor-not-allowed opacity0p5'"
              [disabled]="!pwdFormService.form.valid"
              [size]="'large'"
              (buttonClick)="onSubmit()">
              Continue
            </app-button>

            <app-password-rules [pwdFormService]="pwdFormService"/>
          </form>
        </div>
      </div>
    </div>
  } @else {
    <app-link-is-expired
      [mode]="'Common'"
      [isMobileVersion]="is.mobileVersion"
    />
  }
}
